import pluralize from "pluralize"

import { faIcon } from "@utils/faIcon"

import { Badge } from "@atoms"

import { EstimateCountBadgeProps } from "./EstimateCountBadge.types"

const icon = faIcon({ name: "clock", style: "regular" })

export default function EstimateCountBadge(props: EstimateCountBadgeProps) {
    const { count, tooltip, size = "md" } = props

    const label = `${count} ${pluralize("estimate", count)}`

    return (
        <Badge size={size} variant="icon" icon={icon} tooltip={tooltip ?? label}>
            {label}
        </Badge>
    )
}
